import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../BasePanelPage";
import {Messages} from "../../../../../Messages";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {collapseIframe, collapseIframeAndExpandWallet} from "../../../../../widget/misc/WidgetUtils";
import {PaymentSucceededIcon} from "../../../../../SVGElements";
import {Perk} from "../components/CoverageDescriptionElements";
import {iFrameState} from "../../../../../services/IFrameState";
import {GATE_TYPE} from "../../../../../../blink-sdk/Constants";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {SubscribeThankYouPanelStyle} from "../SubscribeThankYouPanel";


@registerStyle(SubscribeThankYouPanelStyle)
export class EditSubscriptionSuccessPanel extends BasePanelPage {
    renderTextSection() {
        const {styleSheet} = this;

        return iFrameState.gateType === GATE_TYPE.popup ? [
            <div className={styleSheet.message}>{Messages.editSubscriptionSuccessText}</div>,
            <Perk text={Messages.editSubscriptionSuccessPerk1} className={styleSheet.guideline}/>,
            <Perk text={Messages.editSubscriptionSuccessPerk2} className={styleSheet.guideline}/>
        ] : <div className={styleSheet.message}>{Messages.editSubscriptionSuccessTextAccountPage}</div>;
    }

    render() {
        const {styleSheet} = this;

        return [
            <PaymentSucceededIcon className={styleSheet.icon}/>,
            <div className={styleSheet.title}>{Messages.editSubscriptionSuccessTitle}</div>,
            this.renderTextSection(),
            <MerchantButton className={styleSheet.button} onClick={collapseIframe}>
                {Messages.ok}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <div className={styleSheet.secondaryButton} onClick={collapseIframeAndExpandWallet}>
                    {Messages.manageMyAccount}
                </div>
            </div>
        ];
    }
}
